import { render, staticRenderFns } from "./TableViewDetails.vue?vue&type=template&id=496ac5cf&"
import script from "./TableViewDetails.vue?vue&type=script&lang=js&"
export * from "./TableViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports